import { render, staticRenderFns } from "./studentRegister.vue?vue&type=template&id=94f7eac4&scoped=true&"
import script from "./studentRegister.vue?vue&type=script&lang=js&"
export * from "./studentRegister.vue?vue&type=script&lang=js&"
import style0 from "./studentRegister.vue?vue&type=style&index=0&id=94f7eac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f7eac4",
  null
  
)

export default component.exports